/*jshint multistr: true */
// Converted from Prepros prepend directives to explicit ES module imports (order preserved)
import './modules/userscontent.js';
import './modules/popup.js';
import './modules/video_player.js';
import './modules/responsive_embeds.js';

const { articleAds } = document.currentScript.dataset;

$(function () {
    // vanjski urlovi u target="_blank"
    function fixOutsideUrl() {
        $('.article__content a[href^="http"]').attr('target', '_blank');
    }

    // slanje ispravka za članak
    function newArticleCorrect($toggleBtn) {

        var $articleText = $('.js_articleText'),
            $sendCorrectedArticle = $('.js_sendCorrectedArticle'),
            errorTekst = $toggleBtn.data('m_error'),

            app = $toggleBtn.data('m_meta-app-name'),
            model = $toggleBtn.data('m_meta-model-name'),
            pk = $toggleBtn.data('m_meta-pk'),
            articleTitle = $toggleBtn.data('m_meta-article-title');

        $sendCorrectedArticle.on('click', function (e) {
            e.preventDefault();

            if ($articleText.val().length === 0) { return; }

            $.ajax({

                type: 'POST',
                url: $toggleBtn.data('url'),
                data: { 'title': articleTitle, 'correction': $articleText.val(), 'model': model, 'app': app, 'pk': pk },

                success: function (data) {
                    $('.mfp-content .js_modalTitle').text('Članak uspješno prijavljen');
                    $('.mfp-content .js_articleText').slideUp();

                    setTimeout(function () {
                        var magnificPopup = $.magnificPopup.instance;
                        magnificPopup.close();

                    }, 3000);
                },

                statusCode: {

                    403: function () {
                        console.warn('Korisnik nije logiran');

                        $('.mfp-content .js_modalTitle').text(errorTekst).css('color', '#F00');
                        $('.mfp-content .js_articleText').slideUp();
                    },

                    408: function () {
                        console.error('Problem sa serverom - Pokušajte kasnije');
                    },
                    409: function () {

                        $('.mfp-content .js_modalTitle').text(errorTekst).css('color', '#F00');
                        $('.mfp-content .js_articleText').slideUp();
                    },
                    500: function () {
                        console.error('Problem sa serverom - Pokušajte kasnije');
                    },

                    502: function () {
                        console.error('Problem sa serverom - Pokušajte kasnije');
                    }
                }
            });
        });
    }

    // zatvaranje otvorenog modala
    function setModalClose() {

        $('.js_modalClose').addClass('js_modalCloseFN');

        $('.js_modalClose').on('click', function (evt) {
            evt.preventDefault();

            var magnificPopup = $.magnificPopup.instance;
            magnificPopup.close();

        });
    }

    // otvaranje modala za ispravak članka (template mora postojati u članku)
    function initArticleCorrection() {

        $('.js_articleCorrect').magnificPopup({
            modal: true,
            items: {
                src: '#article_correction',
                type: 'inline',
                midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
            },
            callbacks: {
                open: function () {
                    setModalClose();
                    newArticleCorrect($('.js_articleCorrect'));
                }
            }
        });
    }

    function initSendGalleryUrl() {

        if ($('.js_articleGallery').length) {

            var $gallery = $('.js_articleGallery');

            $gallery.each(function (index, element) {

                var $this = $(this),
                    link = $this.attr('href'),
                    $article = window.location.pathname.substr(window.location.pathname.lastIndexOf('-') + 1);

                $this.attr('href', link + '&initialarticle=/a-' + $article);

            });
        }
    }

    function autostartTopGifts() {

        var $topgifts = $('.js_topgifts'),
            $fold = $topgifts.parents('.js_topgiftsFold'),
            $catBtn = $topgifts.find('.js_giftCatBtn'),
            tabsLength = $catBtn.length,
            $list = $topgifts.find('.js_giftList'),
            randNum = Math.floor(Math.random() * (tabsLength));

        if (!$catBtn.length) { return; }

        $fold.removeClass('hidden');

        $catBtn.on('click', function (e) {

            e.preventDefault();

            var $parent = $(this).parent('.js_giftTab');
            randNum = $parent.index();

            $parent.addClass('is_active')
                .siblings('.is_active')
                .removeClass('is_active');

            $list.find('.topgifts__products_list').eq(randNum)
                .addClass('is_active')
                .siblings('.is_active')
                .removeClass('is_active');

        });

        $catBtn.eq(randNum).trigger('click');

    }

    function insertMidasWidget() {
        const articleBody = document.querySelector('.article__body');

        if (!articleBody) return;

        const isMidasEnabled = articleBody.dataset.midasEnabled === 'True';

        if (!isMidasEnabled) return;

        const isPromoArticle = [...articleBody.classList]?.includes('article__promo');

        if (isPromoArticle) return;

        const articleContentElements = articleBody.querySelector('.article__content');

        if (!articleContentElements) return;

        const articleElements = articleContentElements.children;

        if (articleElements.length < 2) return;

        const widgetWrapper = document.createElement('div');
        widgetWrapper.setAttribute('class', 'midas_widget_wrapper');

        const widgetHolder = document.createElement('div');
        widgetHolder.setAttribute('id', 'midasWidget__11206');

        const scriptElement = document.createElement('script');
        scriptElement.setAttribute('async', true);
        scriptElement.setAttribute('src', 'https://cdn2.midas-network.com/Scripts/midasWidget-29-1087-11206.js');

        widgetWrapper.appendChild(widgetHolder);
        widgetWrapper.appendChild(scriptElement);

        articleElements[1].after(widgetWrapper);
    }

    function attemptDfpInitOnArticle() {
        if (dfpDataReady) {
            window.placeForDfp();
        } else {
            setTimeout(() => {
                attemptDfpInitOnArticle();
            }, 300);
        }
    }

    if (articleAds === 'True') {
        attemptDfpInitOnArticle();
        insertMidasWidget();
    }

    fixOutsideUrl();
    initArticleCorrection();
    initSendGalleryUrl();
    autostartTopGifts();
});
